import React, { useEffect, useState } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const CheckoutSignupPage11 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [storedData, setStoredData] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [appointmentUrl, setAppointmentUrl] = useState<string>("");
  const isStaging = process.env.REACT_APP_ENV === "staging";
  const appointmentTypeId = isStaging
    ? process.env.REACT_APP_STAGING_APPOINTMENT_TYPE_ID
    : process.env.REACT_APP_PROD_APPOINTMENT_TYPE_ID;
  const providerId = isStaging
    ? process.env.REACT_APP_STAGING_PROVIDER_ID
    : process.env.REACT_APP_PROD_PROVIDER_ID;

  const openloopurl = isStaging
    ? process.env.REACT_APP_STAGING_OPENLOOP_URL
    : process.env.REACT_APP_PROD_OPENLOOP_URL;

  useEffect(() => {
    const allValues: Record<string, any> = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        try {
          allValues[key] = JSON.parse(value || "");
        } catch {
          allValues[key] = value;
        }
      }
    }
    setStoredData(allValues);

    const firstName = allValues.firstName?.value;
    const lastName = allValues.lastName?.value;
    const email = allValues.email?.value;
    const phoneNumber = allValues.phone?.value;
    const state = allValues.state?.value;

    const url = `${openloopurl}/book-appointment?appointmentTypeId=${appointmentTypeId}&providerId=${providerId}&firstName=${encodeURIComponent(
      firstName
    )}&lastName=${encodeURIComponent(
      lastName
    )}&phoneNumber=${encodeURIComponent(
      phoneNumber
    )}&email=${encodeURIComponent(email)}&state=${encodeURIComponent(
      state
    )}&redirectUrl=https://claya-stage-react-89d77bb7e7c8.herokuapp.com/glp1/getting-started/thank-you`;
    setAppointmentUrl(url);
    localStorage.setItem("step-8-completed", "true");
  }, []);

  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  useEffect(() => {
    const step7Completed = localStorage.getItem("step-7-completed");
    if (step7Completed) {
      safeNavigate("/glp1/getting-started/step-8");
    } else {
      safeNavigate("/glp1/getting-started/step-7");
    }
  }, [location.pathname]);

  return (
    <PageWrapper>
      <div
        className="signup-page-container container"
        style={{ position: "relative" }}
      >
        {loading && (
          <div
            style={{
              position: "absolute",
              top: "0",
              width: "100vw",
              height: "50vh",
              zIndex: "9999",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={60} sx={{ color: "rgb(137, 67, 149)" }} />
          </div>
        )}
        <iframe
          src={appointmentUrl}
          // title="Book Appointment Widget"
          width="100%"
          height="800px"
          style={{
            border: "none",
          }}
          allowFullScreen
          onLoad={() => setLoading(false)}
        />
      </div>
    </PageWrapper>
  );
};
export default CheckoutSignupPage11;
